<twc-popup type="primary" width="l" caption="{{caption| translate}}">
    <twc-popup-content>
        <ng-container *ngIf="reportDetail.length>0; else notResultsFound">
            <span> {{description | translate}} </span>
            <div class="list-view twc-mt-2 ">
                <cw-grid [columns]="columns" [data]="data" (currentPageChange)="onChangePage($event)"
                    [pagination]="getPagination()">
                </cw-grid>
            </div>
        </ng-container>
        <ng-template #notResultsFound>
            <span>{{errorTitle | translate }}</span>
        </ng-template>
    </twc-popup-content>
</twc-popup>